<template>
  <main class="col-xs-12 bg-faded py-3 bg--gray" v-if="show">
    <a @click="desconectar" class="btn btn-logout btn-sm text text__white p-0">Desconectar</a>
    <div class="container">
      <h2 class="h2 text-center margin__bt-50">Selecciona el panel al que te quieres conectar</h2>
      <div class="row d-flex">
        <div class="col-xs-12 col-md-4 mx-auto" v-if="admin">
          <div class="panel text-center">
            <div class="panel-body">
              <h5 class="panel-title">CLOUD</h5>
              <a href="/admin" class="btn btn-primary">Acceder</a>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-md-4 mx-auto" v-if="admin || user.rol === 3 || user.rol === 4">
          <div class="panel text-center">
            <div class="panel-body">
              <h5 class="panel-title">AUDITORÍA</h5>
              <a href="/auditoria" class="btn btn-primary">Acceder</a>
            </div>
          </div>
        </div>

        <div
          class="col-xs-12 col-md-4 mx-auto"
          v-if="user.rol !== 4"
          v-for="(project, index) in projects"
          :key="index"
        >
          <div class="panel text-center">
            <div class="panel-body">
              <h5 class="panel-title">{{ project.project_name }}</h5>
              <a :href="'/dashboard/' + project.id" class="btn btn-primary">Acceder</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapGetters } from "vuex";
import { LOGOUT, FECTH_PROJECTS } from "@/store/actions.type";

export default {
  name: "Home",
  created() {
    this.checkCurrentLogin();
  },
  data() {
    return {
      projects: null,
      errors: null,
      todos: null,
      show: false,
      admin: false,
      user: {}
    };
  },
  methods: {
    checkCurrentLogin() {
      if (localStorage.getItem("user")) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.$store
          .dispatch(FECTH_PROJECTS, {
            id: this.user.id,
            token: this.user.token
          })
          .then(response => (this.projects = response))
          .catch(error => (this.errors = respoonse));
        setTimeout(() => {
          if (this.user.rol == 1) {
            this.admin = true;
            this.show = true;
          } else {
            if (this.projects.length == 1) {
              this.$router.push("/dashboard/" + this.projects[0].id);
            } else {
              this.show = true;
            }
          }
        }, 200);
      }
    },
    desconectar() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.push({ name: "Login" });
      });
    }
  }
};
</script>

<style scoped>
main {
  height: 100vh;
}
.bg--gray {
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue